function Stepper({ currentStep }) {
    const steps = [
        "Family Members",
        "Care Context",
        "Difficult Topics"
    ];

    return (
        <div className="w-full flex justify-center">
            <ul className="steps steps-primary w-fit">
                {steps.map((step, index) => (
                    <li 
                        key={index}
                        className={`step ${index <= currentStep ? 'step-primary' : ''}`}
                        data-content={index + 1}
                    />
                ))}
            </ul>
        </div>
    );
}

export default Stepper;